import { useLocalization } from '@fluent/react';

import ContactPointForm from './ContactPointForm';
import PostalAddressForm from './PostalAddressForm';

const RouteLegForm: React.FC<RouteLegFormProps> = (props) => {
  const { l10n } = useLocalization();

  return (
    <div className="space-y-12">
      <fieldset>
        <legend className="text-lg mb-2 font-bold">{l10n.getString('pick-up')}</legend>
        <RouteLegSingleSideForm {...props} side="start" />
      </fieldset>

      <fieldset>
        <legend className="text-lg mb-2 font-bold">{l10n.getString('destination')}</legend>
        <RouteLegSingleSideForm {...props} side="end" />
      </fieldset>
    </div>
  );
};
export type RouteLegFormProps = {
  name: string;
};

export const RouteLegSingleSideForm: React.FC<RouteLegSingleSideFormProps> = ({ name, side }) => {
  const namePrefix = name ? `${name}.` : '';
  const { l10n } = useLocalization();

  return (
    <div className="space-y-6">
      <div>
        <PostalAddressForm name={`${namePrefix}${side}Location.address`} />
      </div>

      <div>
        <div className="mb-2">
          <span className="label uppercase">{l10n.getString('contact-person')}</span>
        </div>
        <ContactPointForm
          name={`${namePrefix}${side}ContactPoint`}
          showLabel
          hiddenFields={['email']}
        />
      </div>
    </div>
  );
};
export type RouteLegSingleSideFormProps = RouteLegFormProps & {
  side: 'start' | 'end';
};

export default RouteLegForm;
